import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'jquery/dist/jquery';
import 'expose-loader?$!jquery';
import 'expose-loader?jQuery!jquery';
import 'intersection-observer/intersection-observer';
import '../js/sentry';
import 'slick-carousel/slick/slick';
import 'jquery-sticky/jquery.sticky';
import 'reading-time/src/readingTime';
import '../js/web_font_loader';
import '../js/gallery';
import '../js/facebook';
import '../js/youtube';
import '../js/algolia/modal';
import '../js/algolia/search_result_page';
import '../js/content';

require.context('../images', true);
import '../css/orion.scss';

import Rails from "@rails/ujs";
Rails.start();
const Turbolinks = require("turbolinks");
Turbolinks.start();
